import { reactify } from '@zeiss/zui-react';
export const ZuiIconFilesFileReportOverview = reactify('zui-icon-files-file-report-overview');
